import { gql } from '@grandvisionhq/graphql';
import StoreFragment from '../fragments/store.js';
import StoreAppointmentTypesFragment from '../fragments/store-appointment-types.js';
import StoreInventoryFragment from '../fragments/store-inventory.js';
import StoreReservabilityFragment from '../fragments/store-reservability.js';

const GET_PREFERRED_STORE = gql`
  query GetPreferredStore {
    me {
      preferredStore {
        ...Store
        ...StoreAppointmentTypes
      }
    }
  }
  ${StoreFragment}
  ${StoreAppointmentTypesFragment}
`;
const GET_PREFERRED_STORE_WITH_INVENTORY = gql`
  query GetPreferredStoreWithInventory($sku: ID!) {
    me {
      preferredStore {
        ...Store
        ...StoreAppointmentTypes
        ...StoreInventory
        ...StoreReservability
      }
    }
  }
  ${StoreFragment}
  ${StoreAppointmentTypesFragment}
  ${StoreInventoryFragment}
  ${StoreReservabilityFragment}
`;

export { GET_PREFERRED_STORE, GET_PREFERRED_STORE_WITH_INVENTORY };
//# sourceMappingURL=get-preferred-store.js.map
